import { Department } from "../Model/Department";


export class GetDepartmentsList {
    constructor(
      total,
      offset,
      limit,
      records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
      return new GetDepartmentsList(
        data.total,
        data.offset,
        data.limit,
        data.records.map((record) => {
          return Department.createFromResponseData(record);
        }),
      );
    }
  };